"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _variables = require("../../../global-files/variables");

var _templateObject;

var Container = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  width: 100%;\n  height: 100%;\n  min-width: min-content;\n  min-height: min-content;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 6px;\n  padding: 20px 10px;\n  overflow: auto;\n  //border: 1px solid red;\n\n  img {\n    width: 80%;\n    min-width: 35px;\n    max-width: 480px;\n    max-height: 90%;\n    object-fit: contain;\n    //border: 1px solid blue;\n  }\n\n  .divInfo {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    gap: 7px;\n    align-items: center;\n\n    .btnInfo {\n      padding: 0px;\n    }\n\n    .label-error {\n      display: flex;\n      flex-direction: row;\n      flex-wrap: wrap;\n      align-items: center;\n      gap: 3px;\n      font-family: ", ", sans-serif;\n      font-size: 13px;\n      color: #262626;\n\n      label {\n        font-family: ", ", sans-serif;\n        font-size: 15px;\n        color: #e33aa9;\n      }\n    }\n  }\n"])), _variables.FontFamily.RobotoRegular, _variables.FontFamily.RobotoMedium);

exports.Container = Container;